/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'avi-dropdown-options';
const prefix = `${moduleName}.${componentName}`;

export const noValidEntriesLabel = `${prefix}.noValidEntriesLabel`;

export const ENGLISH = {
    [noValidEntriesLabel]: 'no valid entries',
};
